/* Generic, consent-gated feature measurement. No ecommerce ownership or identifiers. */
(function () {
  'use strict';
  if (window.__lumFeatureAnalyticsLoaded) return;
  window.__lumFeatureAnalyticsLoaded = true;
  var destination = 'G-VWMD5SJPG5', seen = new Set(), sessions = new WeakSet(), sequences = new WeakMap();
  var watched = new Set(), visible = new WeakMap(), timers = new WeakMap(), frame;
  function allowed() {
    try { return window.__lumRetailMeasurementId === destination && window.__lumConsentBridge && window.__lumConsentBridge.allowed() === true && typeof window.gtag === 'function'; } catch (e) { return false; }
  }
  function send(name, placement, action, count) {
    if (!allowed()) return false;
    var params = {send_to:destination, placement:placement, action:action,
      page_location:window.location.origin + '/', page_title:'Storefront feature interaction', page_referrer:''};
    if (Number.isFinite(count)) params.item_count = Math.min(100, Math.max(0, Math.floor(count)));
    try { window.gtag('event', name, params); return true; } catch (e) { return false; }
  }
  function placement(node) {
    if (!node || !node.closest) return '';
    if (node.closest('[data-pdp-pairs-with]')) return 'pdp_compact';
    if (node.closest('[data-pdp-related-intent="complementary"]')) return 'pdp_lower';
    if (node.closest('#CartDrawer [data-cart-recommendations]')) return 'cart';
    return '';
  }
  var selector = '[data-pdp-pairs-with] [data-product-id],[data-pdp-related-intent="complementary"] [data-pdp-related-product],#CartDrawer [data-cart-recommendations] [data-cart-recommendation]';
  function key(node) {
    // The existing ID is used only for in-memory deduplication; never transmitted.
    return placement(node) + ':' + (node.dataset.productId || node.dataset.pdpRelatedProduct || node.dataset.cartRecommendation || '');
  }
  function isVisible(node) {
    if (document.visibilityState === 'hidden' || !node.isConnected || node.closest('[hidden],[inert],[aria-hidden="true"]')) return false;
    var style = window.getComputedStyle(node);
    return style.visibility !== 'hidden' && style.display !== 'none' && (!node.checkVisibility || node.checkVisibility({checkOpacity:true,checkVisibilityCSS:true}));
  }
  function check(node) {
    if (timers.has(node)) return;
    if (!allowed() || !visible.get(node) || !isVisible(node) || seen.has(key(node))) return;
    timers.set(node, setTimeout(function () {
      timers.delete(node);
      if (allowed() && visible.get(node) && isVisible(node) && !seen.has(key(node)) && send('lum_pairing_impression', placement(node), 'view', 1)) seen.add(key(node));
    }, 250));
  }
  var observer = typeof IntersectionObserver === 'function' ? new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) { visible.set(entry.target, entry.isIntersecting && entry.intersectionRatio >= 0.5); check(entry.target); });
  }, {threshold:[0,0.5]}) : null;
  function scan() {
    frame = null;
    if (!allowed()) {
      watched.forEach(function (node) { clearTimeout(timers.get(node)); timers.delete(node); });
      return;
    }
    watched.forEach(function (node) { if (!node.isConnected) { if (observer) observer.unobserve(node); watched.delete(node); clearTimeout(timers.get(node)); } else check(node); });
    if (observer) document.querySelectorAll(selector).forEach(function (node) { if (!watched.has(node)) { watched.add(node); observer.observe(node); } check(node); });
  }
  // Coalesce bursts of DOM work (carousels, drawers, class toggles) into one
  // scan a few frames later instead of one per animation frame.
  function schedule() { if (!frame) frame = setTimeout(function () { frame = null; scan(); }, 120); }
  document.addEventListener('luminate:analytics-ready', schedule);
  document.addEventListener('visitorConsentCollected', schedule);
  document.addEventListener('visibilitychange', schedule);
  // Placements live in three known containers; watch only those for
  // visibility changes, and the body only for nodes being added or removed.
  var observer2 = new MutationObserver(schedule);
  function watchContainers() {
    document.querySelectorAll('[data-pdp-pairs-with],[data-pdp-related-intent="complementary"],#CartDrawer').forEach(function (el) {
      if (el.__lumFaWatched) return;
      el.__lumFaWatched = true;
      observer2.observe(el, {subtree:true,childList:true,attributes:true,attributeFilter:['hidden','inert','aria-hidden','class']});
    });
  }
  function onBodyReady() {
    watchContainers();
    new MutationObserver(function () { watchContainers(); schedule(); }).observe(document.body, {childList:true});
  }
  if (document.body) onBodyReady(); else document.addEventListener('DOMContentLoaded', onBodyReady);
  document.addEventListener('luminate:cart-open', schedule);
  document.addEventListener('luminate:cart-rendered', schedule);
  document.addEventListener('luminate:search-open', function (e) {
    var surface = e.detail && e.detail.surface;
    if (surface && !sessions.has(surface) && send('lum_search_interaction', 'predictive_search', 'open')) sessions.add(surface);
  });
  document.addEventListener('luminate:feature-search', function (e) {
    var d = e.detail || {};
    if (!d.surface || ['results','no_results','error'].indexOf(d.action) < 0 || !Number.isInteger(d.sequence)) return;
    if (sequences.get(d.surface) === d.sequence) return;
    if (send('lum_search_interaction', 'predictive_search', d.action, d.count)) sequences.set(d.surface, d.sequence);
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { var s = e.target.closest('[data-predictive-wrap]'); if (s) sessions.delete(s); } }, true);
  document.addEventListener('focusout', function (e) { var s = e.target.closest('[data-predictive-wrap]'); if (s) queueMicrotask(function () { if (!s.contains(document.activeElement)) sessions.delete(s); }); });
  document.addEventListener('submit', function (e) { if (e.target.matches('form[action*="/search"]')) send('lum_search_interaction', 'predictive_search', 'submit'); }, true);
  document.addEventListener('click', function (e) {
    var target = e.target.closest && e.target.closest('a,button'); if (!target) return;
    var surface = target.closest('[data-predictive-wrap]');
    if (surface && target.matches('.lum-search-close')) sessions.delete(surface);
    if (target.closest('[data-predictive-panel]') && target.matches('a')) send('lum_search_interaction', 'predictive_search', target.matches('.predictive__all') ? 'view_all' : target.closest('.lum-search-guidance') ? 'guidance_click' : 'result_click');
    var where = placement(target);
    if (where && (target.matches('a') || target.matches('button[type="submit"]:not(:disabled)'))) send('lum_pairing_click', where, target.closest('.lum-pdp-pair__header') ? 'view_more' : target.matches('a') ? 'product_click' : 'add_click');
  });
  document.addEventListener('luminate:cart-add-success', function (e) {
    var where = e.detail && e.detail.featurePlacement;
    if (['pdp_compact','pdp_lower','cart'].indexOf(where) >= 0) send('lum_pairing_add', where, 'success', 1);
    else if (where === 'predictive_search') send('lum_search_interaction', 'predictive_search', 'add_success', 1);
  });
  document.addEventListener('luminate:feature-cart-open', function (e) {
    var mode = e.detail && e.detail.mode;
    if (mode === 'hover' || mode === 'full') send('lum_cart_open', 'cart', mode);
    schedule();
  });
  schedule();
})();
